import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import goingEvent from '../../global/goingEvent';
import {_isFF} from '../../global/commonUtils';
import dhtmlxArray from './dhtmlxArray';
import {dhtmlXGridComboObject,Hashtable,globalObj} from './dxGridComClass';

/**
 *
 sets one of the predefined skins ("material" (default),"skyblue","web","terrace")
 设置一个预定义的外观（“Material”（默认）、“SkyBlue”、“Web”、“Terrace”）
 * @param name
 */
dhtmlXGridObject.prototype.setSkin = function (name) {
    this._srdh = dhx4.readFromCss("dhxgrid_rh_" + name) + 4;
    this.skin_name = name;
    if (this._imgURL) {
        this.setImagePath(this._imgURL);
    }
    var classname = this.entBox.className.split(" gridbox")[0];
    this.entBox.className =
        classname +
            " gridbox gridbox_" +
            name +
            (dhx4.isIE ? " isIE" : " isModern");
    this.skin_h_correction = 0;
    this.enableAlterCss("ev_" + name, "odd_" + name, this.isTreeGrid());
    this._fixAlterCss();
    switch (name) {
        case "dhx_terrace":
        case "material":
            this.forceDivInHeader = true;
            this._srdh = 31;
            break;
        case "dhx_skyblue":
            this.forceDivInHeader = true;
            break;
    }
    if (dhx4.isIE && this.hdr) {
        var d = this.hdr.parentNode;
        d.removeChild(this.hdr);
        d.appendChild(this.hdr);
    }
    this.setSizes();
};
/**
 * 将网格附加到DOM中的某个对象
 * @param obj
 */
dhtmlXGridObject.prototype.attachToObject = function (obj) {
    obj.appendChild(this.globalBox ? this.globalBox : this.entBox);
    this.setSizes();
};
/**
 * 表格初始化方法
 * @param fl
 */
dhtmlXGridObject.prototype.init = function (fl) {
    if (this.isTreeGrid() && !this._h2) {
        this._h2 = this._createHierarchy();
        if (this._fake && !this._realfake) {
            this._fake._h2 = this._h2;
        }
        this._tgc = { imgURL: null };
    }
    if (!this._hstyles) {
        return;
    }
    if (!this.skin_name) {
        this.setSkin(dhx4.skin ||
            (typeof dhtmlx != "undefined" ? dhtmlx.skin : null) ||
            dhx4.skinDetect("dhxgrid") ||
            "material");
    }
    this.editStop();
    this.lastClicked = null;
    this.resized = null;
    this.fldSorted = this.r_fldSorted = null;
    this.cellWidthPX = [];
    this.cellWidthPC = [];
    if (this.hdr.rows.length > 0) {
        var temp = this.xmlFileUrl;
        this.clearAll(true);
        this.xmlFileUrl = temp;
    }
    var hdrRow = this.hdr.insertRow(0);
    for (var i = 0; i < this.hdrLabels.length; i++) {
        hdrRow.appendChild(document.createElement("TH"));
        hdrRow.childNodes[i]._cellIndex = i;
        hdrRow.childNodes[i].style.height = "0px";
    }
    if (dhx4.isIE &&
        dhx4.isIE < 8 &&
        document.body.style.msTouchAction == this.undefined) {
        hdrRow.style.position = "absolute";
    }
    else {
        hdrRow.style.height = "auto";
    }
    hdrRow = this.hdr.insertRow(window._isKHTML ? 2 : 1);
    hdrRow._childIndexes = new Array();
    var col_ex = 0;
    for (var i_1 = 0; i_1 < this.hdrLabels.length; i_1++) {
        hdrRow._childIndexes[i_1] = i_1 - col_ex;
        if (this.hdrLabels[i_1] == this.splitSign && i_1 != 0) {
            if (window._isKHTML) {
                hdrRow.insertCell(i_1 - col_ex);
            }
            hdrRow.cells[i_1 - col_ex - 1].colSpan =
                (hdrRow.cells[i_1 - col_ex - 1].colSpan || 1) + 1;
            hdrRow.childNodes[i_1 - col_ex - 1]._cellIndex++;
            col_ex++;
            hdrRow._childIndexes[i_1] = i_1 - col_ex;
            continue;
        }
        hdrRow.insertCell(i_1 - col_ex);
        hdrRow.childNodes[i_1 - col_ex]._cellIndex = i_1;
        hdrRow.childNodes[i_1 - col_ex]._cellIndexS = i_1;
        this.setColumnLabel(i_1, this.hdrLabels[i_1]);
    }
    if (col_ex == 0) {
        hdrRow._childIndexes = null;
    }
    this._cCount = this.hdrLabels.length;
    if (dhx4.isIE) {
        var self = this;
        window.setTimeout(function () {
            if (self.setSizes) {
                self.setSizes();
            }
        }, 1);
    }
    if (!this.obj.firstChild) {
        this.obj.appendChild(document.createElement("TBODY"));
    }
    var tar = this.obj.firstChild;
    if (!tar.firstChild) {
        tar.appendChild(document.createElement("TR"));
        tar = tar.firstChild;
        if (dhx4.isIE &&
            dhx4.isIE < 8 &&
            document.body.style.msTouchAction == this.undefined) {
            tar.style.position = "absolute";
        }
        else {
            tar.style.height = "auto";
        }
        for (var i_2 = 0; i_2 < this.hdrLabels.length; i_2++) {
            tar.appendChild(document.createElement("TH"));
            tar.childNodes[i_2].style.height = "0px";
        }
    }
    this._c_order = null;
    if (this.multiLine != true) {
        this.obj.className += " row20px";
    }
    this.sortImg.style.position = "absolute";
    this.sortImg.style.display = "none";
    this.sortImg.className = "goingicon go-arrowdown dhxgrid_sort_desc";
    this.sortImg.defLeft = 0;
    if (this.noHeader) {
        this.hdrBox.style.display = "none";
    }
    else {
        this.noHeader = false;
    }
    if (this._ivizcol) {
        this.setColHidden();
    }
    this.attachHeader();
    this.attachHeader(0, 0, "_aFoot");
    this.setSizes();
    if (fl) {
        this.parseXML();
    }
    this.obj.scrollTop = 0;
    if (this.dragAndDropOff) {
        this.dragger.addDragLanding(this.entBox, this);
    }
    if (this._initDrF) {
        this._initD();
    }
    dhx4.callEvent("onGridCreated", [this]);
};
dhtmlXGridObject.prototype.setColumnSizes = function (gridWidth) {
    var summ = 0;
    var fcols = [];
    var fix = 0;
    for (var i = 0; i < this._cCount; i++) {
        if (this.initCellWidth[i] == "*" && !this._hrrar[i]) {
            this._awdth = false;
            fcols.push(i);
            continue;
        }
        if (this.cellWidthType == "%") {
            if (typeof this.cellWidthPC[i] == "undefined") {
                this.cellWidthPC[i] = this.initCellWidth[i];
            }
            var cwidth = (gridWidth * this.cellWidthPC[i]) / 100 || 0;
            if (fix > 0.5) {
                cwidth++;
                fix--;
            }
            var rwidth = (this.cellWidthPX[i] = Math.floor(cwidth));
            fix = fix + cwidth - rwidth;
        }
        else {
            if (typeof this.cellWidthPX[i] == "undefined") {
                this.cellWidthPX[i] = this.initCellWidth[i];
            }
        }
        if (!this._hrrar[i]) {
            summ += this.cellWidthPX[i] * 1;
        }
    }
    if (fcols.length) {
        var ms = Math.floor((gridWidth - summ) / fcols.length);
        if (ms < 0) {
            ms = 1;
        }
        for (var i_3 = 0; i_3 < fcols.length; i_3++) {
            var next = Math.max(this._drsclmW ? this._drsclmW[fcols[i_3]] || 0 : 0, ms);
            this.cellWidthPX[fcols[i_3]] = next;
            summ += next;
        }
        if (gridWidth > summ) {
            var last = fcols[fcols.length - 1];
            this.cellWidthPX[last] = this.cellWidthPX[last] + (gridWidth - summ);
            summ = gridWidth;
        }
        this._setAutoResize();
    }
    this.obj.style.width = summ + "px";
    this.hdr.style.width = summ + "px";
    if (this.ftr) {
        this.ftr.style.width = summ + "px";
    }
    this.chngCellWidth();
    return summ;
};
/**
 * 重置表格元素的大小
 */
dhtmlXGridObject.prototype.setSizes = function () {
    if (!this.hdr.rows[0]) {
        return;
    }
    var quirks = (this.quirks = dhx4.isIE && document.compatMode == "BackCompat");
    var outerBorder = (this.entBox.offsetWidth - this.entBox.clientWidth) / 2;
    if (!this.dontSetSizes) {
        if (this.globalBox) {
            if (!this.globalBox.clientWidth) {
                return;
            }
            var ow = this.globalBox.clientWidth;
            var splitOuterBorder = (this.globalBox.offsetWidth - ow) / 2;
            if (this._delta_x && !this._realfake) {
                this.globalBox.style.width = this._delta_x;
                var owu = this.globalBox.clientWidth;
                this.entBox.style.width =
                    Math.max(0, owu +
                        (quirks ? splitOuterBorder * 2 : 0) -
                        this._fake.entBox.clientWidth) + "px";
                if (owu != this._lastTimeSplitWidth) {
                    this._fake._correctSplit(this._fake.entBox.clientWidth);
                    this._lastTimeSplitWidth = owu;
                }
            }
            if (this._delta_y && !this._realfake) {
                this.globalBox.style.height = this._delta_y;
                this.entBox.style.overflow = this._fake.entBox.style.overflow =
                    "hidden";
                this.entBox.style.height = this._fake.entBox.style.height =
                    this.globalBox.clientHeight +
                        (quirks ? splitOuterBorder * 2 : 0) +
                        "px";
            }
        }
        else {
            if (this._delta_x) {
                if (this.entBox.parentNode && this.entBox.parentNode.tagName == "TD") {
                    this.entBox.style.width = "1px";
                    this.entBox.style.width =
                        (parseInt(this._delta_x) * this.entBox.parentNode.clientWidth) /
                            100 -
                            outerBorder * 2 +
                            "px";
                }
                else {
                    this.entBox.style.width = this._delta_x;
                }
            }
            if (this._delta_y) {
                this.entBox.style.height = this._delta_y;
            }
        }
    }
    window.clearTimeout(this._sizeTime);
    if (!this.entBox.offsetWidth &&
        (!this.globalBox || !this.globalBox.offsetWidth)) {
        var self = this;
        this._sizeTime = window.setTimeout(function () {
            if (self.setSizes) {
                self.setSizes();
            }
        }, 250);
        return;
    }
    var border_x = !this._wthB &&
        ((this.entBox.cmp || this._delta_x) &&
            (this.skin_name || "").indexOf("dhx") == 0 &&
            !quirks)
        ? 2
        : 0;
    var border_y = !this._wthB &&
        ((this.entBox.cmp || this._delta_y) &&
            (this.skin_name || "").indexOf("dhx") == 0 &&
            !quirks)
        ? 2
        : 0;
    if (this._sizeFix) {
        border_x -= this._sizeFix;
        border_y -= this._sizeFix;
    }
    var isVScroll = this.parentGrid
        ? false
        : this.objBox.scrollHeight > this.objBox.offsetHeight;
    var scrfix = dhtmlx.$customScroll ? 0 : 18;
    var gridWidth = this.entBox.clientWidth -
        (this.skin_h_correction || 0) * (quirks ? 0 : 1) -
        border_x;
    var gridWidthActive = this.entBox.clientWidth - (this.skin_h_correction || 0) - border_x;
    var gridHeight = this.entBox.clientHeight - border_y;
    var summ = this.setColumnSizes(gridWidthActive - (isVScroll ? scrfix : 0) - (this._correction_x || 0));
    var isHScroll = this.parentGrid
        ? false
        : this.objBox.scrollWidth > this.objBox.offsetWidth ||
            this.objBox.style.overflowX == "scroll";
    var headerHeight = this.hdr.clientHeight;
    var footerHeight = this.ftr ? this.ftr.clientHeight : 0;
    var newWidth = gridWidth;
    var newHeight = gridHeight - headerHeight - footerHeight;
    if (this._awdth && this._awdth[0] && this._awdth[1] == 99999) {
        isHScroll = 0;
    }
    if (this._ahgr) {
        if (this._ahgrMA) {
            newHeight =
                this.entBox.parentNode.clientHeight - headerHeight - footerHeight;
        }
        else {
            newHeight =
                this.obj.offsetHeight +
                    (isHScroll ? scrfix : 0) +
                    (this._correction_y || 0);
        }
        if (this._ahgrM) {
            if (this._ahgrF) {
                newHeight =
                    Math.min(this._ahgrM, newHeight + headerHeight + footerHeight) -
                        headerHeight -
                        footerHeight;
            }
            else {
                newHeight = Math.min(this._ahgrM, newHeight);
            }
        }
        if (isVScroll &&
            newHeight >= this.obj.scrollHeight + (isHScroll ? scrfix : 0)) {
            isVScroll = false;
            this.setColumnSizes(gridWidthActive - (this._correction_x || 0));
        }
    }
    if (this._awdth && this._awdth[0]) {
        if (this.cellWidthType == "%") {
            this.cellWidthType = "px";
        }
        if (this._fake) {
            summ += this._fake.entBox.clientWidth;
        }
        newWidth =
            Math.min(Math.max(summ + (isVScroll ? scrfix : 0), this._awdth[2]), this._awdth[1]) + (this._correction_x || 0);
        this.objBox.style.overflowX =
            !isVScroll && this.objBox.scrollWidth <= newWidth ? "hidden" : "auto";
        if (this._fake) {
            newWidth -= this._fake.entBox.clientWidth;
        }
    }
    newHeight = Math.max(0, newHeight);
    this._ff_size_delta = this._ff_size_delta == 0.1 ? 0.2 : 0.1;
    if (!_isFF) {
        this._ff_size_delta = 0;
    }
    if (!this.dontSetSizes) {
        this.entBox.style.width =
            Math.max(0, newWidth + (quirks ? 2 : 0) * outerBorder + this._ff_size_delta) + "px";
        this.entBox.style.height =
            newHeight +
                (quirks ? 2 : 0) * outerBorder +
                headerHeight +
                footerHeight +
                "px";
    }
    this.objBox.style.height =
        newHeight + (quirks && !isVScroll ? 2 : 0) * outerBorder + "px";
    this.hdrBox.style.height = headerHeight + "px";
    if (newHeight != gridHeight) {
        this.doOnScroll(0, !this._srnd);
    }
    var ext = this["setSizes_" + this.skin_name];
    if (ext) {
        ext.call(this);
    }
    this.setSortImgPos();
    if (headerHeight != this.hdr.clientHeight && this._ahgr) {
        this.setSizes();
    }
    this.callEvent("onSetSizes", []);
};
/**
 * 改变cell单元格的宽度信息
 */
dhtmlXGridObject.prototype.chngCellWidth = function () {
    if (dhx4.isOpera && this.ftr) {
        this.ftr.width = this.objBox.scrollWidth + "px";
    }
    var l = this._cCount;
    for (var i = 0; i < l; i++) {
        this.hdr.rows[0].cells[i].style.width = this.cellWidthPX[i] + "px";
        this.obj.rows[0].childNodes[i].style.width = this.cellWidthPX[i] + "px";
        if (this.ftr) {
            this.ftr.rows[0].cells[i].style.width = this.cellWidthPX[i] + "px";
        }
    }
};
/**
 * 设置列表值中使用的分隔符（默认值为“，”
 * @param delim
 */
dhtmlXGridObject.prototype.setDelimiter = function (delim) {
    this.delim = delim;
};
/**
 * 按百分比设置列的宽度
 * @param wp
 */
dhtmlXGridObject.prototype.setInitWidthsP = function (wp) {
    this.cellWidthType = "%";
    this.initCellWidth = wp.split(this.delim.replace(/px/gi, ""));
    if (!arguments[1]) {
        this._setAutoResize();
    }
};
dhtmlXGridObject.prototype._setAutoResize = function () {
    if (this._realfake) {
        return;
    }
    var self = this;
    //注册界面的resize事件
    goingEvent(window, "resize", function () {
        window.clearTimeout(self._resize_timer);
        if (self._setAutoResize) {
            self._resize_timer = window.setTimeout(function () {
                if (self.setSizes) {
                    self.setSizes();
                }
                if (self._fake) {
                    self._fake._correctSplit();
                }
            }, 100);
        }
    });
    this._setAutoResize = function () { };
};
/**
 * 以像素为单位设置列的宽度
 * mygrid.setInitWidths("150,100,100,100,100");
 * @param wp
 */
dhtmlXGridObject.prototype.setInitWidths = function (wp) {
    this.cellWidthType = "px";
    this.initCellWidth = wp.split(this.delim);
    if (_isFF) {
        for (var i = 0; i < this.initCellWidth.length; i++) {
            if (this.initCellWidth[i] != "*") {
                this.initCellWidth[i] = parseInt(this.initCellWidth[i]);
            }
        }
    }
};
/**
 * 将多行支持设置为启用/禁用状态
 * @param state
 */
dhtmlXGridObject.prototype.enableMultiline = function (state) {
    this.multiLine = dhx4.s2b(state);
};
/**
 * 将多行选中 设置为启用/禁用状态
 * @param state
 */
dhtmlXGridObject.prototype.enableMultiselect = function (state) {
    this.selMultiRows = dhx4.s2b(state);
};
/**
 * 设置表格图片路径
 * @param path
 */
dhtmlXGridObject.prototype.setImagePath = function (path) {
    if(path==null){
        return void(0);
    }
    path = path.replace(/imgs\/dhxgrid_[a-z]*\/$/, "imgs/");
    this._imgURL = path;
    this.imgURL =
        path +
            "dhxgrid_" +
            (this.skin_name || "dhx_skyblue").replace("dhx_", "") +
            "/";
    this.iconTree = this.imgURL + "tree/";
};
dhtmlXGridObject.prototype.setImagesPath = dhtmlXGridObject.prototype.setImagePath;
dhtmlXGridObject.prototype.setIconPath = function (path) {
    this.iconURL = path;
};
dhtmlXGridObject.prototype.setIconsPath = dhtmlXGridObject.prototype.setIconPath;
dhtmlXGridObject.prototype.changeCursorState = function (ev) {
    var el = ev.target || ev.srcElement;
    if (el.tagName != "TD") {
        el = this.getFirstParentOfType(el, "TD");
    }
    if (!el) {
        return;
    }
    if (el.tagName == "TD" && this._drsclmn && !this._drsclmn[el._cellIndex]) {
        return (el.style.cursor = "default");
    }
    var check = (ev.layerX || 0) +
        (!dhx4.isIE && ev.target.tagName == "DIV" ? el.offsetLeft : 0);
    if (el.offsetWidth -
        (ev.offsetX ||
            (parseInt(this.getPosition(el, this.hdrBox)) - check) * -1) <
        (dhx4.isOpera ? 20 : 10)) {
        el.style.cursor = "E-resize";
    }
    else {
        el.style.cursor = "default";
    }
    if (dhx4.isOpera) {
        this.hdrBox.scrollLeft = this.objBox.scrollLeft;
    }
};
dhtmlXGridObject.prototype.startColResize = function (ev) {
    var self = this;
    if (this.resized) {
        this.stopColResize();
    }
    this.resized = null;
    var el = ev.target || ev.srcElement;
    if (el.tagName != "TD") {
        el = this.getFirstParentOfType(el, "TD");
    }
    var x = ev.clientX;
    var tabW = this.hdr.offsetWidth;
    var startW = parseInt(el.offsetWidth);
    if (el.tagName == "TD" && el.style.cursor != "default") {
        if (this._drsclmn && !this._drsclmn[el._cellIndex]) {
            return;
        }
        self._old_d_mm = document.body.onmousemove;
        self._old_d_mu = document.body.onmouseup;
        document.body.onmousemove = function (e) {
            if (self) {
                self.doColResize(e || window.event, el, startW, x, tabW);
            }
        };
        document.body.onmouseup = function () {
            if (self) {
                self.stopColResize();
            }
        };
    }
};
dhtmlXGridObject.prototype.stopColResize = function () {
    var self = this;
    document.body.onmousemove = self._old_d_mm || "";
    document.body.onmouseup = self._old_d_mu || "";
    this.setSizes();
    this.doOnScroll(0, 1);
    this.callEvent("onResizeEnd", [this]);
};
dhtmlXGridObject.prototype.doColResize = function (ev, el, startW, x) {
    el.style.cursor = "E-resize";
    this.resized = el;
    var fcolW = startW + (ev.clientX - x);
    if (!this.callEvent("onResize", [el._cellIndex, fcolW, this])) {
        return;
    }
    if (dhx4.isIE) {
        this.objBox.scrollLeft = this.hdrBox.scrollLeft;
    }
    var result = false;
    if (el.colSpan > 1) {
        var a_sizes = new Array();
        for (var i = 0; i < el.colSpan; i++) {
            a_sizes[i] = Math.round((fcolW * this.hdr.rows[0].childNodes[el._cellIndexS + i].offsetWidth) /
                el.offsetWidth);
        }
        for (var i_4 = 0; i_4 < el.colSpan; i_4++) {
            result = this._setColumnSizeR(el._cellIndexS + i_4 * 1, a_sizes[i_4]);
        }
    }
    else {
        result = this._setColumnSizeR(el._cellIndex, fcolW);
    }
    this.doOnScroll(0, 1);
    this.setSizes();
    if (this._fake && this._awdth) {
        this._fake._correctSplit();
    }
    return result;
};
dhtmlXGridObject.prototype._setColumnSizeR = function (ind, fcolW) {
    if (fcolW > (this._drsclmW && !this._notresize ? this._drsclmW[ind] || 10 : 10)) {
        this.obj.rows[0].childNodes[ind].style.width = fcolW + "px";
        this.hdr.rows[0].childNodes[ind].style.width = fcolW + "px";
        if (this.ftr) {
            this.ftr.rows[0].childNodes[ind].style.width = fcolW + "px";
        }
        if (this.cellWidthType == "px") {
            this.cellWidthPX[ind] = fcolW;
        }
        else {
            var gridWidth = parseInt(this.entBox.offsetWidth);
            if (this.objBox.scrollHeight > this.objBox.offsetHeight) {
                gridWidth -= 17;
            }
            var pcWidth = Math.round((fcolW / gridWidth) * 100);
            this.cellWidthPC[ind] = pcWidth;
        }
        if (this.sortImg.style.display != "none") {
            this.setSortImgPos();
        }
    }
    else {
        return false;
    }
};
/**
 * 设置排序箭头的位置和可见性
 * @param state
 * @param ind
 * @param order
 * @param row
 */
dhtmlXGridObject.prototype.setSortImgState = function (state, ind, order, row) {
    order = (order || "asc").toLowerCase();
    if (!dhx4.s2b(state)) {
        this.sortImg.style.display = "none";
        if (this.r_fldSorted) {
            this.r_fldSorted.className = "";
        }
        this.fldSorted = this.r_fldSorted = null;
        return;
    }
    if (order == "asc") {
        this.sortImg.className = "goingicon go-arrowup dhxgrid_sort_asc";
    }
    else {
        this.sortImg.className = "goingicon go-arrowdown dhxgrid_sort_desc";
    }
    this.sortImg.style.display = "";
    this.fldSorted = this.hdr.rows[0].childNodes[ind];
    var r = this.hdr.rows[row || 1];
    if (!r) {
        return;
    }
    for (var i = 0; i < r.childNodes.length; i++) {
        if (r.childNodes[i]._cellIndexS == ind) {
            this.r_fldSorted = r.childNodes[i];
            return this.setSortImgPos();
        }
    }
    return this.setSortImgState(state, ind, order, (row || 1) + 1);
};
dhtmlXGridObject.prototype.setSortImgPos = function (ind, mode, hRowInd, el) {
    if (this._hrrar &&
        this._hrrar[this.r_fldSorted ? this.r_fldSorted._cellIndex : ind]) {
        return;
    }
    if (this.ar_fldSorted) {
        this.ar_fldSorted.className = "";
    }
    if (!el) {
        if (!ind) {
            el = this.r_fldSorted;
        }
        else {
            el = this.hdr.rows[hRowInd || 0].cells[ind];
        }
    }
    if (el != null) {
        var pos = this.getPosition(el, this.hdrBox);
        var wdth = el.offsetWidth;
        this.ar_fldSorted = el;
        el.className = this.sortImg.className + "_col";
        this.sortImg.style.left = Number(pos[0] + wdth - 13) + "px";
        this.sortImg.defLeft = parseInt(this.sortImg.style.left);
        this.sortImg.style.top = Number(pos[1] + 5) + "px";
        if (!this.useImagesInHeader && !mode) {
            this.sortImg.style.display = "inline";
        }
        this.sortImg.style.left = this.sortImg.defLeft + "px";
    }
};
/**
 * 将表格设置为活动状态以使关键点导航成为可能
 * @param fl
 */
dhtmlXGridObject.prototype.setActive = function (fl) {
    if (arguments.length == 0) {
        fl = true;
    }
    if (fl == true) {
        if (globalObj.globalActiveDHTMLGridObject && globalObj.globalActiveDHTMLGridObject != this) {
            globalObj.globalActiveDHTMLGridObject.editStop();
            globalObj.globalActiveDHTMLGridObject.callEvent("onBlur", [
                globalObj.globalActiveDHTMLGridObject
            ]);
        }
        globalObj.globalActiveDHTMLGridObject = this;
        this.isActive = true;
    }
    else {
        this.isActive = false;
        this.callEvent("onBlur", [this]);
    }
};
dhtmlXGridObject.prototype._doClick = function (ev) {
    var selMethod = 0;
    var el = this.getFirstParentOfType(dhx4.isIE ? ev.srcElement : ev.target, "TD");
    if (!el || !el.parentNode || !el.parentNode.idd) {
        return;
    }
    var fl = true;
    if (this.markedCells) {
        var markMethod = 0;
        if (ev.shiftKey || ev.metaKey) {
            markMethod = 1;
        }
        if (ev.ctrlKey) {
            markMethod = 2;
        }
        this.doMark(el, markMethod);
        return true;
    }
    if (this.selMultiRows != false) {
        if (ev.shiftKey && this.row != null && this.selectedRows.length) {
            selMethod = 1;
        }
        if (ev.ctrlKey || ev.metaKey) {
            selMethod = 2;
        }
    }
    return this.doClick(el, fl, selMethod, false);
};
dhtmlXGridObject.prototype._doContClick = function (ev) {
    var el = this.getFirstParentOfType(dhx4.isIE ? ev.srcElement : ev.target, "TD");
    if (!el || typeof el.parentNode.idd == "undefined") {
        this.callEvent("onEmptyClick", [ev]);
        return true;
    }
    if (ev.button == 2 || (dhx4.isMacOS && ev.ctrlKey)) {
        if (!this.callEvent("onRightClick", [el.parentNode.idd, el._cellIndex, ev])) {
            var z = function (e) {
                (e || event).cancelBubble = true;
                return false;
            };
            (ev.srcElement || ev.target).oncontextmenu = z;
            return z(ev);
        }
        if (this._ctmndx) {
            if (!this.callEvent("onBeforeContextMenu", [
                el.parentNode.idd,
                el._cellIndex,
                this
            ])) {
                return true;
            }
            if (dhx4.isIE) {
                ev.srcElement.oncontextmenu = function () {
                    event.cancelBubble = true;
                    return false;
                };
            }
            if (this._ctmndx.showContextMenu) {
                var dEl0 = window.document.documentElement;
                var dEl1 = window.document.body;
                var corrector = new Array(dEl0.scrollLeft || dEl1.scrollLeft, dEl0.scrollTop || dEl1.scrollTop);
                var x, y = null;
                if (dhx4.isIE) {
                    x = ev.clientX + corrector[0];
                    y = ev.clientY + corrector[1];
                }
                else {
                    x = ev.pageX;
                    y = ev.pageY;
                }
                this._ctmndx.showContextMenu(x - 1, y - 1);
                this.contextID = this._ctmndx.contextMenuZoneId =
                    el.parentNode.idd + "_" + el._cellIndex;
                this._ctmndx._skip_hide = true;
            }
            else {
                el.contextMenuId = el.parentNode.idd + "_" + el._cellIndex;
                el.contextMenu = this._ctmndx;
                el.a = this._ctmndx._contextStart;
                el.a(el, ev);
                el.a = null;
            }
            ev.cancelBubble = true;
            return false;
        }
    }
    else {
        if (this._ctmndx) {
            if (this._ctmndx.hideContextMenu) {
                this._ctmndx.hideContextMenu();
            }
            else {
                this._ctmndx._contextEnd();
            }
        }
    }
    return true;
};
dhtmlXGridObject.prototype.doClick = function (el, fl, selMethod, show) {
    if (!this.selMultiRows) {
        selMethod = 0;
    }
    var psid = this.row ? this.row.idd : 0;
    var skipRowSelection = null;
    this.setActive(true);
    if (!selMethod) {
        selMethod = 0;
    }
    if (this.cell != null) {
        this.cell.className = this.cell.className.replace(/cellselected/g, "");
    }
    if (el.tagName == "TD") {
        if (this.checkEvent("onSelectStateChanged")) {
            var initial = this.getSelectedId();
        }
        var prow = this.row;
        var strt, end = null;
        if (selMethod == 1) {
            var elRowIndex = this.rowsCol._dhx_find(el.parentNode);
            var lcRowIndex = this.rowsCol._dhx_find(this.lastClicked);
            if (elRowIndex > lcRowIndex) {
                strt = lcRowIndex;
                end = elRowIndex;
            }
            else {
                strt = elRowIndex;
                end = lcRowIndex;
            }
            for (var i = 0; i < this.rowsCol.length; i++) {
                if (i >= strt && i <= end) {
                    if (this.rowsCol[i] && !this.rowsCol[i]._sRow) {
                        if (!this.rowsCol[i].idd) {
                            continue;
                        }
                        if (this.rowsCol[i].className.indexOf("rowselected") == -1 &&
                            this.callEvent("onBeforeSelect", [
                                this.rowsCol[i].idd,
                                psid,
                                el._cellIndex
                            ])) {
                            this.rowsCol[i].className += " rowselected";
                            this.selectedRows[this.selectedRows.length] = this.rowsCol[i];
                        }
                    }
                    else {
                        this.clearSelection();
                        return this.doClick(el, fl, 0, show);
                    }
                }
            }
        }
        else {
            if (selMethod == 2) {
                if (el.parentNode.className.indexOf("rowselected") != -1) {
                    el.parentNode.className = el.parentNode.className.replace(/rowselected/g, "");
                    this.selectedRows._dhx_removeAt(this.selectedRows._dhx_find(el.parentNode));
                    skipRowSelection = true;
                    show = false;
                }
            }
        }
        this.editStop();
        if (typeof el.parentNode.idd == "undefined") {
            return true;
        }
        if (!skipRowSelection && !el.parentNode._sRow) {
            if (this.callEvent("onBeforeSelect", [
                el.parentNode.idd,
                psid,
                el._cellIndex
            ])) {
                if (this.getSelectedRowId() != el.parentNode.idd) {
                    if (selMethod == 0) {
                        this.clearSelection();
                    }
                    this.cell = el;
                    if (prow == el.parentNode && this._chRRS) {
                        fl = false;
                    }
                    this.row = el.parentNode;
                    this.row.className += " rowselected";
                    if (this.selectedRows._dhx_find(this.row) == -1) {
                        this.selectedRows[this.selectedRows.length] = this.row;
                    }
                }
                else {
                    this.cell = el;
                    this.row = el.parentNode;
                }
            }
            else {
                fl = false;
            }
        }
        if (this.cell &&
            this.cell.parentNode.className.indexOf("rowselected") != -1) {
            this.cell.className =
                this.cell.className.replace(/cellselected/g, "") + " cellselected";
        }
        if (selMethod != 1) {
            if (!this.row) {
                return;
            }
        }
        this.lastClicked = el.parentNode;
        var rid = this.row.idd;
        var cid = this.cell;
        if (fl && typeof rid != "undefined" && cid && !skipRowSelection) {
            var self = this;
            self.onRowSelectTime = setTimeout(function () {
                if (self.callEvent) {
                    self.callEvent("onRowSelect", [rid, cid._cellIndex]);
                }
            }, 100);
        }
        else {
            this.callEvent("onRowSelectRSOnly", [rid]);
        }
        if (this.checkEvent("onSelectStateChanged")) {
            var afinal = this.getSelectedId();
            if (initial != afinal) {
                this.callEvent("onSelectStateChanged", [afinal, initial]);
            }
        }
        if (skipRowSelection) {
            return false;
        }
    }
    this.isActive = true;
    if (show !== false && this.cell && this.cell.parentNode.idd) {
        this.moveToVisible(this.cell);
    }
};
/**
 * 选择表格中的所有行，不触发任何事件
 */
dhtmlXGridObject.prototype.selectAll = function () {
    this.clearSelection();
    var coll = this.rowsBuffer;
    if (this.pagingOn) {
        coll = this.rowsCol;
    }
    for (var i = 0; i < coll.length; i++) {
        this.render_row(i).className += " rowselected";
    }
    this.selectedRows = new dhtmlxArray([].concat(coll));
    if (this.selectedRows.length) {
        this.row = this.selectedRows[0];
        this.cell = this.row.cells[0];
    }
    if (this._fake && !this._realfake) {
        this._fake.selectAll();
    }
};
/**
 * 将所选内容设置为指定的行单元格
 * myTreeGrid.selectCell(0,1,true,true);
 * @param r
 * @param cInd
 * @param fl
 * @param preserve
 * @param edit
 * @param show
 */
dhtmlXGridObject.prototype.selectCell = function (r, cInd, fl, preserve, edit, show) {
    if (!fl) {
        fl = false;
    }
    if (typeof r != "object") {
        r = this.render_row(r);
    }
    if (!r || r == -1) {
        return null;
    }
    var c = null;
    if (r._childIndexes) {
        c = r.childNodes[r._childIndexes[cInd]];
    }
    else {
        c = r.childNodes[cInd];
    }
    if (!c) {
        c = r.childNodes[0];
    }
    if (!this.markedCells) {
        if (preserve) {
            this.doClick(c, fl, 3, show);
        }
        else {
            this.doClick(c, fl, 0, show);
        }
    }
    else {
        this.doMark(c, preserve ? 2 : 0);
    }
    if (edit) {
        this.editCell();
    }
};
dhtmlXGridObject.prototype.moveToVisible = function (cell_obj, onlyVScroll) {
    if (this.pagingOn) {
        var newPage = Math.floor(this.getRowIndex(cell_obj.parentNode.idd) / this.rowsBufferOutSize) + 1;
        if (newPage != this.currentPage) {
            this.changePage(newPage);
        }
    }
    try {
        if (cell_obj.offsetHeight) {
            var distance = cell_obj.offsetLeft + cell_obj.offsetWidth + 20;
            var scrollLeft = 0;
            if (distance > this.objBox.offsetWidth + this.objBox.scrollLeft) {
                if (cell_obj.offsetLeft > this.objBox.scrollLeft) {
                    scrollLeft =
                        cell_obj.offsetLeft -
                            (this.objBox.offsetWidth - cell_obj.offsetWidth) +
                            5;
                }
            }
            else {
                if (cell_obj.offsetLeft < this.objBox.scrollLeft) {
                    distance -= (cell_obj.offsetWidth * 2) / 3;
                    if (distance < this.objBox.scrollLeft) {
                        scrollLeft = cell_obj.offsetLeft - 5;
                    }
                }
            }
            if (scrollLeft && !onlyVScroll) {
                this.objBox.scrollLeft = scrollLeft;
            }
        }
        if (!cell_obj.offsetHeight) {
            var mask = this._realfake
                ? this._fake.rowsAr[cell_obj.parentNode.idd]
                : cell_obj.parentNode;
            distance = this.rowsBuffer._dhx_find(mask) * this._srdh;
        }
        else {
            distance = cell_obj.offsetTop;
        }
        var distancemax = distance + cell_obj.offsetHeight + 38;
        var scrollTop = null;
        if (distancemax > this.objBox.offsetHeight + this.objBox.scrollTop) {
            scrollTop = distance;
        }
        else {
            if (distance < this.objBox.scrollTop) {
                scrollTop = distance - 5;
            }
        }
        if (scrollTop) {
            this.objBox.scrollTop = scrollTop;
        }
    }
    catch (er) {
        console.log(er,"--er-");
    }
};
/**
 * 创建编辑器对象并将所选单元格切换到编辑模式（如果允许）
 * myGrid.selectCell(rowIndex,cellIndex);
   myGrid.editCell();
 */
dhtmlXGridObject.prototype.editCell = function () {
    if (this.editor && this.cell == this.editor.cell) {
        return;
    }
    this.editStop();
    if (this.isEditable != true || !this.cell) {
        return false;
    }
    var c = this.cell;
    if (c.parentNode._locked) {
        return false;
    }
    this.editor = this.cells4(c);
    if (this.editor != null) {
        if (this.editor.isDisabled()) {
            this.editor = null;
            return false;
        }
        if (this.callEvent("onEditCell", [0, this.row.idd, this.cell._cellIndex]) !=
            false &&
            this.editor.edit) {
            this._Opera_stop = new Date().valueOf();
            c.className += " editable";
            this.editor.edit();
            this.callEvent("onEditCell", [1, this.row.idd, this.cell._cellIndex]);
        }
        else {
            this.editor = null;
        }
    }
};
/**
 * 将编辑器中的值（如果存在）返回到单元格并关闭编辑器
 * if true - current edit value will be reverted to the previous one
 * @param mode
 */
dhtmlXGridObject.prototype.editStop = function (mode) {
    if (dhx4.isOpera) {
        if (this._Opera_stop) {
            if (this._Opera_stop * 1 + 50 > new Date().valueOf()) {
                return;
            }
            this._Opera_stop = null;
        }
    }
    if (this.editor && this.editor != null) {
        this.editor.cell.className = this.editor.cell.className.replace("editable", "");
        if (mode) {
            var t = this.editor.val;
            this.editor.detach();
            this.editor.setValue(t);
            this.editor = null;
            this.callEvent("onEditCancel", [this.row.idd, this.cell._cellIndex, t]);
            return;
        }
        if (this.editor.detach()) {
            this.cell.wasChanged = true;
        }
        var g = this.editor;
        if (g == null) {
            return;
        }
        this.editor = null;
        var z = this.callEvent("onEditCell", [
            2,
            this.row.idd,
            this.cell._cellIndex,
            g.getValue(),
            g.val
        ]);
        if (typeof z == "string" || typeof z == "number") {
            g[g.setImage ? "setLabel" : "setValue"](z);
        }
        else {
            if (!z) {
                g[g.setImage ? "setLabel" : "setValue"](g.val);
            }
        }
        if (this._ahgr && this.multiLine) {
            this.setSizes();
        }
    }
};
dhtmlXGridObject.prototype._nextRowCell = function (row, dir, pos) {
    row = this._nextRow((this._groups ? this.rowsCol : this.rowsBuffer)._dhx_find(row), dir);
    if (!row) {
        return null;
    }
    return row.childNodes[row._childIndexes ? row._childIndexes[pos] : pos];
};
dhtmlXGridObject.prototype._getNextCell = function (acell, dir, i) {
    acell = acell || this.cell;
    var arow = acell.parentNode;
    if (this._tabOrder) {
        i = this._tabOrder[acell._cellIndex];
        if (typeof i != "undefined") {
            if (i < 0) {
                acell = this._nextRowCell(arow, dir, Math.abs(i) - 1);
            }
            else {
                acell = arow.childNodes[i];
            }
        }
    }
    else {
        i = acell._cellIndex + dir;
        if (i >= 0 && i < this._cCount) {
            if (arow._childIndexes) {
                i = arow._childIndexes[acell._cellIndex] + dir;
            }
            acell = arow.childNodes[i];
        }
        else {
            acell = this._nextRowCell(arow, dir, dir == 1 ? 0 : this._cCount - 1);
        }
    }
    if (!acell) {
        if (dir == 1 && this.tabEnd) {
            this.tabEnd.focus();
            this.tabEnd.focus();
            this.setActive(false);
        }
        if (dir == -1 && this.tabStart) {
            this.tabStart.focus();
            this.tabStart.focus();
            this.setActive(false);
        }
        return null;
    }
    if (acell.style.display != "none" &&
        (!this.smartTabOrder ||
            !this.cells(acell.parentNode.idd, acell._cellIndex).isDisabled())) {
        return acell;
    }
    return this._getNextCell(acell, dir);
};
dhtmlXGridObject.prototype._nextRow = function (ind, dir) {
    var r = this.render_row(ind + dir);
    if (!r || r == -1) {
        return null;
    }
    if (r && r.style.display == "none") {
        return this._nextRow(ind + dir, dir);
    }
    return r;
};
dhtmlXGridObject.prototype.scrollPage = function (dir) {
    if (!this.rowsBuffer.length) {
        return;
    }
    var master = this._realfake ? this._fake : this;
    var new_ind = Math.floor((master._r_select || this.getRowIndex(this.row.idd) || 0) +
        (dir * this.objBox.offsetHeight) / (this._srdh || 20));
    if (new_ind < 0) {
        new_ind = 0;
    }
    if (new_ind >= this.rowsBuffer.length) {
        new_ind = this.rowsBuffer.length - 1;
    }
    if (this._srnd && !this.rowsBuffer[new_ind]) {
        this.objBox.scrollTop +=
            Math.floor((dir * this.objBox.offsetHeight) / (this._srdh || 20)) *
                (this._srdh || 20);
        if (this._fake) {
            this._fake.objBox.scrollTop = this.objBox.scrollTop;
        }
        master._r_select = new_ind;
    }
    else {
        this.selectCell(new_ind, this.cell._cellIndex, true, false, false, this.multiLine || this._srnd);
        if (!this.multiLine && !this._srnd && !this._realfake) {
            this.objBox.scrollTop = this.getRowById(this.getRowId(new_ind)).offsetTop;
            if (this._fake) {
                this._fake.objBox.scrollTop = this.objBox.scrollTop;
            }
        }
        master._r_select = null;
    }
};
dhtmlXGridObject.prototype.doKey = function (ev) {
    if (!ev) {
        return true;
    }
    if ((ev.target || ev.srcElement).value !== window.undefined) {
        var zx = ev.target || ev.srcElement;
        if (zx.className != "dhxcombo_input" &&
            (!zx.parentNode || zx.parentNode.className.indexOf("editable") == -1)) {
            return true;
        }
    }
    if (globalObj.globalActiveDHTMLGridObject && this != globalObj.globalActiveDHTMLGridObject) {
        return globalObj.globalActiveDHTMLGridObject.doKey(ev);
    }

    if (this.isActive == false) {
        return true;
    }
    if (this._htkebl) {
        return true;
    }

    if (!this.callEvent("onKeyPress", [ev.keyCode, ev.ctrlKey||ev.metaKey, ev.shiftKey, ev])) {
        return false;
    }
    var code = "k" + ev.keyCode + "_" + (ev.ctrlKey ? 1 : 0) + "_" + (ev.shiftKey ? 1 : 0);
    if (this.cell) {
        if (this._key_events[code]) {
            if (false === this._key_events[code].call(this)) {
                return true;
            }
            if (ev.preventDefault) {
                ev.preventDefault();
            }
            ev.cancelBubble = true;
            return false;
        }
        if (this._key_events.k_other) {
            this._key_events.k_other.call(this, ev);
        }
    }
    return true;
};
dhtmlXGridObject.prototype.selectRow = function (r, fl, preserve, show) {
    if (typeof r != "object") {
        r = this.render_row(r);
    }
    this.selectCell(r, 0, fl, preserve, false, show);
};
dhtmlXGridObject.prototype.wasDblClicked = function (ev) {
    var el = this.getFirstParentOfType(dhx4.isIE ? ev.srcElement : ev.target, "TD");
    if (el) {
        var rowId = el.parentNode.idd;
        return this.callEvent("onRowDblClicked", [rowId, el._cellIndex, ev]);
    }
};
dhtmlXGridObject.prototype._onHeaderClick = function (e, el) {
    var that = this.grid;
    el =
        el ||
            that.getFirstParentOfType(window._isIE ? event.srcElement : e.target, "TD");
    if (this.grid.resized == null) {
        if (!this.grid.callEvent("onHeaderClick", [el._cellIndexS, e || window.event])) {
            return false;
        }
        that.sortField(el._cellIndexS, false, el);
    }
    this.grid.resized = null;
};
/**
 * 删除所选行
 */
dhtmlXGridObject.prototype.deleteSelectedRows = function () {
    var num = this.selectedRows.length;
    if (num == 0) {
        return;
    }
    var tmpAr = this.selectedRows;
    this.selectedRows = new dhtmlxArray();
    var ind = null;
    for (var i = num - 1; i >= 0; i--) {
        var node = tmpAr[i];
        if (!this.deleteRow(node.idd, node)) {
            this.selectedRows[this.selectedRows.length] = node;
        }
        else {
            if (node == this.row) {
                ind = i;
            }
        }
    }
    if (ind) {
        try {
            if (ind + 1 > this.rowsCol.length) {
                ind--;
            }
            this.selectCell(ind, 0, true);
        }
        catch (er) {
            this.row = null;
            this.cell = null;
        }
    }
};
/**
 * 返回所选行的ID（具有默认分隔符的ID列表）或空（如果没有所选行）
 */
dhtmlXGridObject.prototype.getSelectedRowId = function () {
    var selAr = new Array(0);
    var uni = {};
    for (var i = 0; i < this.selectedRows.length; i++) {
        var id = this.selectedRows[i].idd;
        if (uni[id]) {
            continue;
        }
        selAr[selAr.length] = id;
        uni[id] = true;
    }
    if (selAr.length == 0) {
        return null;
    }
    else {
        return selAr.join(this.delim);
    }
};
/**
 * 返回选定单元格的索引，如果没有选定单元格，则返回-1
 */
dhtmlXGridObject.prototype.getSelectedCellIndex = function () {
    if (this.cell != null) {
        return this.cell._cellIndex;
    }
    else {
        return -1;
    }
};
/**
 * 获取指定列的宽度（像素）
 * @param ind
 */
dhtmlXGridObject.prototype.getColWidth = function (ind) {
    return parseInt(this.cellWidthPX[ind]);
};
/**
 * 以像素为单位设置指定列的宽度（不适用于基于百分比的网格）
 * @param ind
 * @param value
 */
dhtmlXGridObject.prototype.setColWidth = function (ind, value) {
    if (value == "*") {
        this.initCellWidth[ind] = "*";
    }
    else {
        if (this._hrrar[ind]) {
            return;
        }
        if (this.cellWidthType == "px") {
            this.cellWidthPX[ind] = parseInt(value);
        }
        else {
            this.cellWidthPC[ind] = parseInt(value);
        }
    }
    this.setSizes();
};
/**
 * 按行ID获取行索引（仅网格）
 * @param row_id
 */
dhtmlXGridObject.prototype.getRowIndex = function (row_id) {
    for (var i = 0; i < this.rowsBuffer.length; i++) {
        if (this.rowsBuffer[i] && this.rowsBuffer[i].idd == row_id) {
            return i;
        }
    }
    return -1;
};
/**
 * 根据行索引来获取行id
 * @param ind
 */
dhtmlXGridObject.prototype.getRowId = function (ind) {
    return this.rowsBuffer[ind] ? this.rowsBuffer[ind].idd : this.undefined;
};
/**
 * 按行的索引设置行的新ID
 * @param ind
 * @param row_id
 */
dhtmlXGridObject.prototype.setRowId = function (ind, row_id) {
    this.changeRowId(this.getRowId(ind), row_id);
};
/**
 * 将行的ID更改为新的ID
 * @param oldRowId
 * @param newRowId
 */
dhtmlXGridObject.prototype.changeRowId = function (oldRowId, newRowId) {
    if (oldRowId == newRowId) {
        return;
    }
    var row = this.rowsAr[oldRowId];
    row.idd = newRowId;
    if (this.UserData[oldRowId]) {
        this.UserData[newRowId] = this.UserData[oldRowId];
        this.UserData[oldRowId] = null;
    }
    if (this._h2 && this._h2.get[oldRowId]) {
        this._h2.get[newRowId] = this._h2.get[oldRowId];
        this._h2.get[newRowId].id = newRowId;
        delete this._h2.get[oldRowId];
    }
    this.rowsAr[oldRowId] = null;
    this.rowsAr[newRowId] = row;
    for (var i = 0; i < row.childNodes.length; i++) {
        if (row.childNodes[i]._code) {
            row.childNodes[i]._code = this._compileSCL(row.childNodes[i]._val, row.childNodes[i]);
        }
    }
    if (this._mat_links && this._mat_links[oldRowId]) {
        var a = this._mat_links[oldRowId];
        delete this._mat_links[oldRowId];
        for (var c in a) {
            for (var i_5 = 0; i_5 < a[c].length; i_5++) {
                this._compileSCL(a[c][i_5].original, a[c][i_5]);
            }
        }
    }
    this.callEvent("onRowIdChange", [oldRowId, newRowId]);
};
/**
 * 为每列设置ID
 * @param ids
 */
dhtmlXGridObject.prototype.setColumnIds = function (ids) {
    this.columnIds = ids.split(this.delim);
};
/**
 * 设置指定列的ID
 * @param ind
 * @param id
 */
dhtmlXGridObject.prototype.setColumnId = function (ind, id) {
    this.columnIds[ind] = id;
};
/**
 * 按列ID获取列索引
 * @param id
 */
dhtmlXGridObject.prototype.getColIndexById = function (id) {
    for (var i = 0; i < this.columnIds.length; i++) {
        if (this.columnIds[i] == id) {
            return i;
        }
    }
};
/**
 * 获取由索引指定的列的ID
 * @param cin
 */
dhtmlXGridObject.prototype.getColumnId = function (cin) {
    return this.columnIds[cin];
};
/**
 * 获取由索引指定的列的标签
 * @param cin
 * @param ind
 * @param hdr
 * @param raw
 */
dhtmlXGridObject.prototype.getColumnLabel = function (cin, ind, hdr, raw) {
    var z = (hdr || this.hdr).rows[(ind || 0) + 1];
    for (var i = 0; i < z.cells.length; i++) {
        if (z.cells[i]._cellIndexS == cin) {
            return raw
                ? z.cells[i].firstChild.innerHTML
                : dhx4.isIE
                    ? z.cells[i].innerText
                    : z.cells[i].textContent;
        }
    }
    return "";
};
dhtmlXGridObject.prototype.getColLabel = dhtmlXGridObject.prototype.getColumnLabel;
/**
 * 获取由索引指定的页脚标签
 * @param cin
 * @param ind
 * @param raw
 */
dhtmlXGridObject.prototype.getFooterLabel = function (cin, ind, raw) {
    return this.getColumnLabel(cin, ind, this.ftr, raw);
};
dhtmlXGridObject.prototype.setRowTextBold = function (row_id) {
    var r = this.getRowById(row_id);
    if (r) {
        r.style.fontWeight = "bold";
    }
};
dhtmlXGridObject.prototype.setRowTextStyle = function (row_id, styleString) {
    var r = this.getRowById(row_id);
    if (!r) {
        return;
    }
    for (var i = 0; i < r.childNodes.length; i++) {
        var pfix = r.childNodes[i]._attrs.style || "";
        if (this._hrrar && this._hrrar[i]) {
            pfix = "display:none;";
        }
        if (dhx4.isIE) {
            r.childNodes[i].style.cssText =
                pfix + "width:" + r.childNodes[i].style.width + ";" + styleString;
        }
        else {
            r.childNodes[i].style.cssText =
                pfix + "width:" + r.childNodes[i].style.width + ";" + styleString;
        }
    }
};
/**
 * 根据行id 设置当前行的颜色
 * @param row_id
 * @param color
 */
dhtmlXGridObject.prototype.setRowColor = function (row_id, color) {
    var r = this.getRowById(row_id);
    for (var i = 0; i < r.childNodes.length; i++) {
        r.childNodes[i].bgColor = color;
    }
};
/**
 * 清除行对背景颜色
 * @param row_id
 * @param color
 */
dhtmlXGridObject.prototype.clearRowColor = function (row_id, color) {
    var r = this.getRowById(row_id);
    for (var i = 0; i < r.childNodes.length; i++) {
        $(r.childNodes[i]).removeAttr("bgcolor");
    }
};
/**
 * 设置单元格样式
 * @param row_id
 * @param ind
 * @param styleString
 * mygrid.setCellTextStyle("row1",0,"color:red;border:1px solid gray;");
 */
dhtmlXGridObject.prototype.setCellTextStyle = function (row_id, ind, styleString) {
    var r = this.getRowById(row_id);
    if (!r) {
        return;
    }
    var cell = r.childNodes[r._childIndexes ? r._childIndexes[ind] : ind];
    if (!cell) {
        return;
    }
    var pfix = "";
    if (this._hrrar && this._hrrar[ind]) {
        pfix = "display:none;";
    }
    if (dhx4.isIE) {
        cell.style.cssText = pfix + "width:" + cell.style.width + ";" + styleString;
    }
    else {
        cell.style.cssText = pfix + "width:" + cell.style.width + ";" + styleString;
    }
};
/**
 * 将行的文本权重设置为普通
 * @param row_id
 * mygrid.setRowTextNormal("row1");
 */
dhtmlXGridObject.prototype.setRowTextNormal = function (row_id) {
    var r = this.getRowById(row_id);
    if (r) {
        r.style.fontWeight = "normal";
    }
};
/**
 * 确定是否存在具有指定ID的行
 * @param row_id
 * var exist=myGrid.doesRowExist("some_row_ID");
 */
dhtmlXGridObject.prototype.doesRowExist = function (row_id) {
    if (this.getRowById(row_id) != null) {
        return true;
    }
    else {
        return false;
    }
};
/**
 * 返回网格中的列数（包括隐藏列）
 * var colNum=myGrid.getColumnsNum();
 */
dhtmlXGridObject.prototype.getColumnsNum = function () {
    return this._cCount;
};
/**
 *如果可能，将行上移一个位置
 * @param row_id
 * <a href="javascript:void(0)" onclick="myGrid.moveRowUp(myGrid.getSelectedId())">
 Move selected row up
 </a>
 */
dhtmlXGridObject.prototype.moveRowUp = function (row_id) {
    var r = this.getRowById(row_id);
    if (this.isTreeGrid()) {
        return this.moveRowUDTG(row_id, -1);
    }
    var rInd = this.rowsCol._dhx_find(r);
    if (r.previousSibling && rInd != 0) {
        r.parentNode.insertBefore(r, r.previousSibling);
        this.rowsCol._dhx_swapItems(rInd, rInd - 1);
        this.setSizes();
        var bInd = this.rowsBuffer._dhx_find(r);
        this.rowsBuffer._dhx_swapItems(bInd, bInd - 1);
        if (this._cssEven) {
            this._fixAlterCss(rInd - 1);
        }
    }
};
dhtmlXGridObject.prototype.moveRowDown = function (row_id) {
    var r = this.getRowById(row_id);
    if (this.isTreeGrid()) {
        return this.moveRowUDTG(row_id, 1);
    }
    var rInd = this.rowsCol._dhx_find(r);
    if (r.nextSibling) {
        this.rowsCol._dhx_swapItems(rInd, rInd + 1);
        if (r.nextSibling.nextSibling) {
            r.parentNode.insertBefore(r, r.nextSibling.nextSibling);
        }
        else {
            r.parentNode.appendChild(r);
        }
        this.setSizes();
        var bInd = this.rowsBuffer._dhx_find(r);
        this.rowsBuffer._dhx_swapItems(bInd, bInd + 1);
        if (this._cssEven) {
            this._fixAlterCss(rInd);
        }
    }
};
dhtmlXGridObject.prototype.getCombo = function (col_ind) {
    if (!this.combos[col_ind]) {
        this.combos[col_ind] = new dhtmlXGridComboObject();
    }
    return this.combos[col_ind];
};
dhtmlXGridObject.prototype.setUserData = function (row_id, name, value) {
    if (!row_id) {
        row_id = "gridglobaluserdata";
    }
    if (!this.UserData[row_id]) {
        this.UserData[row_id] = new Hashtable();
    }
    this.UserData[row_id].put(name, value);
};
dhtmlXGridObject.prototype.getUserData = function (row_id, name) {
    if (!row_id) {
        row_id = "gridglobaluserdata";
    }
    this.getRowById(row_id);
    var z = this.UserData[row_id];
    return z ? z.get(name) : "";
};
dhtmlXGridObject.prototype.setEditable = function (fl) {
    this.isEditable = dhx4.s2b(fl);
};
dhtmlXGridObject.prototype.selectRowById = function (row_id, multiFL, show, call) {
    if (!call) {
        call = false;
    }
    this.selectCell(this.getRowById(row_id), 0, call, multiFL, false, show);
};
dhtmlXGridObject.prototype.clearSelection = function () {
    this.editStop();
    for (var i = 0; i < this.selectedRows.length; i++) {
        var r = this.rowsAr[this.selectedRows[i].idd];
        if (r) {
            r.className = r.className.replace(/rowselected/g, "");
        }
    }
    this.selectedRows = new dhtmlxArray();
    this.row = null;
    if (this.cell != null) {
        this.cell.className = this.cell.className.replace(/cellselected/g, "");
        this.cell = null;
    }
    this.callEvent("onSelectionCleared", []);
};
dhtmlXGridObject.prototype.copyRowContent = function (from_row_id, to_row_id) {
    var frRow = this.getRowById(from_row_id);
    if (!this.isTreeGrid()) {
        for (var i = 0; i < frRow.cells.length; i++) {
            this.cells(to_row_id, i).setValue(this.cells(from_row_id, i).getValue());
        }
    }
    else {
        this._copyTreeGridRowContent(frRow, from_row_id, to_row_id);
    }
    if (!dhx4.isIE) {
        this.getRowById(from_row_id).cells[0].height = frRow.cells[0].offsetHeight;
    }
};
dhtmlXGridObject.prototype.setFooterLabel = function (c, label, ind) {
    return this.setColumnLabel(c, label, ind, this.ftr);
};
dhtmlXGridObject.prototype.setColumnLabel = function (c, label, ind, hdr) {
    var z = (hdr || this.hdr).rows[ind || 1];
    var col = z._childIndexes ? z._childIndexes[c] : c;
    if (!z.cells[col]) {
        return;
    }
    if (!this.useImagesInHeader) {
        var hdrHTML = "<div class='hdrcell'>";
        if (label.indexOf("img:[") != -1) {
            var imUrl = label.replace(/.*\[([^>]+)\].*/, "$1");
            label = label.substr(label.indexOf("]") + 1, label.length);
            hdrHTML +=
                "<img width='18px' height='18px' align='absmiddle' src='" +
                    imUrl +
                    "' hspace='2'>";
        }
        hdrHTML += label;
        hdrHTML += "</div>";
        z.cells[col].innerHTML = hdrHTML;
        if (this._hstyles[c]) {
            z.cells[col].style.cssText = this._hstyles[c];
        }
    }
    else {
        z.cells[col].style.textAlign = "left";
        z.cells[col].innerHTML = "<img src='" + label + "'>";
        var a = new Image();
        a.src = "" + label.replace(/(\.[a-z]+)/, ".des$1");
        this.preloadImagesAr[this.preloadImagesAr.length] = a;
        var b = new Image();
        b.src = "" + label.replace(/(\.[a-z]+)/, ".asc$1");
        this.preloadImagesAr[this.preloadImagesAr.length] = b;
    }
    if ((label || "").indexOf("#") != -1) {
        var t = label.match(/(^|{)#([^}]+)(}|$)/);
        if (t) {
            var tn = "_in_header_" + t[2];
            if (this[tn]) {
                this[tn](this.forceDivInHeader ? z.cells[col].firstChild : z.cells[col], col, label.split(t[0]));
            }
        }
    }
};
dhtmlXGridObject.prototype.setColLabel = function (a, b, ind, c) {
    return this.setColumnLabel(a, b, (ind || 0) + 1, c);
};
dhtmlXGridObject.prototype.clearAll = function (header) {
    if (!this.obj.rows[0]) {
        return;
    }
    if (this._h2) {
        this._h2 = this._createHierarchy();
        if (this._fake) {
            if (this._realfake) {
                this._h2 = this._fake._h2;
            }
            else {
                this._fake._h2 = this._h2;
            }
        }
    }
    this.limit = this._limitC = 0;
    this.editStop(true);
    if (this._dLoadTimer) {
        window.clearTimeout(this._dLoadTimer);
    }
    if (this._dload) {
        this.objBox.scrollTop = 0;
        this.limit = this._limitC || 0;
        this._initDrF = true;
    }
    var len = this.rowsCol.length;
    var t_r = null;
    len = this.obj.rows.length;
    for (var i = len - 1; i > 0; i--) {
        t_r = this.obj.rows[i];
        t_r.parentNode.removeChild(t_r);
    }
    if (header) {
        this._master_row = null;
        this.obj.rows[0].parentNode.removeChild(this.obj.rows[0]);
        for (var i_6 = this.hdr.rows.length - 1; i_6 >= 0; i_6--) {
            t_r = this.hdr.rows[i_6];
            t_r.parentNode.removeChild(t_r);
        }
        if (this.ftr) {
            this.ftr.parentNode.removeChild(this.ftr);
            this.ftr = null;
        }
        this._aHead = this.ftr = this.cellWidth = this._aFoot = null;
        this.cellType = new dhtmlxArray();
        this._hrrar = [];
        this.columnIds = [];
        this.combos = [];
        this._strangeParams = [];
        this.defVal = [];
        this._ivizcol = null;
    }
    this.row = null;
    this.cell = null;
    this.rowsCol = new dhtmlxArray();
    this.rowsAr = {};
    this._RaSeCol = [];
    this.rowsBuffer = new dhtmlxArray();
    this.UserData = [];
    this.selectedRows = new dhtmlxArray();
    if (this.pagingOn || this._srnd) {
        this.xmlFileUrl = "";
    }
    if (this.pagingOn) {
        this.changePage(1);
    }
    if (this._contextCallTimer) {
        window.clearTimeout(this._contextCallTimer);
    }
    if (this._sst) {
        this.enableStableSorting(true);
    }
    this._fillers = this.undefined;
    this.setSortImgState(false);
    this.setSizes();
    this.callEvent("onClearAll", []);
};
dhtmlXGridObject.prototype.sortField = function (ind, repeatFl, r_el) {
    if (this.getRowsNum() == 0) {
        return false;
    }
    var el = this.hdr.rows[0].cells[ind];
    if (!el) {
        return;
    }
    if (el.tagName == "TH" &&
        this.fldSort.length - 1 >= el._cellIndex &&
        this.fldSort[el._cellIndex] != "na") {
        var data = this.getSortingState();
        var sortType = data[0] == ind && data[1] == "asc" ? "des" : "asc";
        if (!this.callEvent("onBeforeSorting", [ind, this.fldSort[ind], sortType])) {
            return;
        }
        this.sortImg.className =  ` goingicon go-${sortType == "asc" ? "arrowup" : "arrowdown"}`+" dhxgrid_sort_" + (sortType == "asc" ? "asc" : "desc");
        if (this.useImagesInHeader) {
            var cel = this.hdr.rows[1].cells[el._cellIndex].firstChild;
            if (this.fldSorted != null) {
                var celT = this.hdr.rows[1].cells[this.fldSorted._cellIndex].firstChild;
                celT.src = celT.src.replace(/(\.asc\.)|(\.des\.)/, ".");
            }
            cel.src = cel.src.replace(/(\.[a-z]+)$/, "." + sortType + "$1");
        }
        this.sortRows(el._cellIndex, this.fldSort[el._cellIndex], sortType);
        this.fldSorted = el;
        if (r_el && r_el.tagName.toLowerCase() != "th") {
            this.r_fldSorted = r_el;
        }
        // var c = this.hdr.rows[1];
        // c = r_el.parentNode;
        // var real_el = c._childIndexes
        //     ? c._childIndexes[el._cellIndex]
        //     : el._cellIndex;
        this.setSortImgPos(false, false, false, r_el);
    }
};
dhtmlXGridObject.prototype.setCustomSorting = function (func, col) {
    if (!this._customSorts) {
        this._customSorts = new Array();
    }
    this._customSorts[col] = typeof func == "string" ? eval(func) : func;
    this.fldSort[col] = "cus";
};
dhtmlXGridObject.prototype.enableHeaderImages = function (fl) {
    this.useImagesInHeader = fl;
};
dhtmlXGridObject.prototype._eSplit = function (str) {
    if (![].push) {
        return str.split(this.delim);
    }
    var a = "r" + new Date().valueOf();
    var z = this.delim.replace(/([\|\+\*\^])/g, "\\$1");
    return (str || "")
        .replace(RegExp(z, "g"), a)
        .replace(RegExp("\\\\" + a, "g"), this.delim)
        .split(a);
};
dhtmlXGridObject.prototype.setHeader = function (hdrStr, splitSign, styles, hdrLength) {
    this._colSize = hdrLength;
    if (typeof hdrStr != "object") {
        var arLab = this._eSplit(hdrStr);
    }
    else {
        arLab = [].concat(hdrStr);
    }
    var arWdth = new Array(0);
    var arTyp = new dhtmlxArray(0);
    var arAlg = new Array(0);
    var arVAlg = new Array(0);
    var arSrt = new Array(0);
    for (var i = 0; i < arLab.length; i++) {
        arWdth[arWdth.length] = Math.round(100 / arLab.length);
        arTyp[arTyp.length] = "ed";
        arAlg[arAlg.length] = "left";
        arVAlg[arVAlg.length] = "middle";
        arSrt[arSrt.length] = "na";
    }
    this.splitSign = splitSign || "#cspan";
    this.hdrLabels = arLab;
    this.cellWidth = arWdth;
    if (!this.initCellWidth.length) {
        this.setInitWidthsP(arWdth.join(this.delim), true);
    }
    this.cellType = arTyp;
    this.cellAlign = arAlg;
    this.cellVAlign = arVAlg;
    this.fldSort = arSrt;
    this._hstyles = styles || [];
};
dhtmlXGridObject.prototype.getColType = function (cInd) {
    return this.cellType[cInd];
};
dhtmlXGridObject.prototype.getColTypeById = function (cID) {
    return this.cellType[this.getColIndexById(cID)];
};
dhtmlXGridObject.prototype.setColTypes = function (typeStr) {
    this.cellType = new dhtmlxArray(typeStr.split(this.delim));
    this._strangeParams = new Array();
    for (var i = 0; i < this.cellType.length; i++) {
        if (this.cellType[i].indexOf("[") != -1) {
            var z = this.cellType[i].split(/[\[\]]+/g);
            this.cellType[i] = z[0];
            this.defVal[i] = z[1];
            if (z[1].indexOf("=") == 0) {
                this.cellType[i] = "math";
                this._strangeParams[i] = z[0];
            }
        }
        if (!window["eXcell_" + this.cellType[i]]) {
            console.log("eXcell_" + this.cellType[i] + "方法不存在，请确认！");
            dhx4.callEvent("onConfigurationError", [
                "Incorrect cell type: " + this.cellType[i],
                this,
                this.cellType[i]
            ]);
        }
    }
};
dhtmlXGridObject.prototype.setColSorting = function (sortStr) {
    this.fldSort = sortStr.split(this.delim);
    var check = { str: 1, int: 1, date: 1 };
    for (var i = 0; i < this.fldSort.length; i++) {
        if (!check[this.fldSort[i]] &&
            typeof window[this.fldSort[i]] == "function") {
            if (!this._customSorts) {
                this._customSorts = new Array();
            }
            this._customSorts[i] = window[this.fldSort[i]];
            this.fldSort[i] = "cus";
        }
    }
};
dhtmlXGridObject.prototype.setColAlign = function (alStr) {
    this.cellAlign = alStr.split(this.delim);
    for (var i = 0; i < this.cellAlign.length; i++) {
        this.cellAlign[i] = this.cellAlign[i]._dhx_trim();
    }
};
dhtmlXGridObject.prototype.setColVAlign = function (valStr) {
    this.cellVAlign = valStr.split(this.delim);
};
dhtmlXGridObject.prototype.setNoHeader = function (fl) {
    this.noHeader = dhx4.s2b(fl);
};
dhtmlXGridObject.prototype.showRow = function (rowID) {
    this.getRowById(rowID);
    if (this._h2) {
        this.openItem(this._h2.get[rowID].parent.id);
    }
    var c = this.getRowById(rowID).childNodes[0];
    while (c && c.style.display == "none") {
        c = c.nextSibling;
    }
    if (c) {
        this.moveToVisible(c, true);
    }
};
dhtmlXGridObject.prototype.setStyle = function (ss_header, ss_grid, ss_selCell, ss_selRow) {
    this.ssModifier = [ss_header, ss_grid, ss_selCell, ss_selCell, ss_selRow];
    var prefs = [
        "#" + this.entBox.id + " table.hdr td",
        "#" + this.entBox.id + " table.obj td",
        "#" + this.entBox.id + " table.obj tr.rowselected td.cellselected",
        "#" + this.entBox.id + " table.obj td.cellselected",
        "#" + this.entBox.id + " table.obj tr.rowselected td"
    ];
    var index = 0;
    while (!dhx4.isIE) {
        try {
            document.styleSheets[index].cssRules.length;
        }
        catch (e) {
            index++;
            continue;
        }
        break;
    }
    for (var i = 0; i < prefs.length; i++) {
        if (this.ssModifier[i]) {
            if (dhx4.isIE) {
                document.styleSheets[0].addRule(prefs[i], this.ssModifier[i]);
            }
            else {
                document.styleSheets[index].insertRule(prefs[i] + (" { " + this.ssModifier[i] + " }"), document.styleSheets[index].cssRules.length);
            }
        }
    }
};
dhtmlXGridObject.prototype.setColumnColor = function (clr) {
    this.columnColor = clr.split(this.delim);
};
dhtmlXGridObject.prototype.enableAlterCss = function (cssE, cssU, perLevel, levelUnique) {
    if (cssE || cssU) {
        this.attachEvent("onGridReconstructed", function () {

            this._fixAlterCss();

            if (this._fake) {

                this._fake._fixAlterCss();
            }
        });
    }
    this._cssSP = perLevel;
    this._cssSU = levelUnique;
    this._cssEven = cssE;
    this._cssUnEven = cssU;
};
dhtmlXGridObject.prototype._fixAlterCss = function (ind) {
    if (this._h2 && (this._cssSP || this._cssSU)) {
        return this._fixAlterCssTGR(ind);
    }
    if (!this._cssEven && !this._cssUnEven) {
        return;
    }
    ind = ind || 0;
    var j = ind;
    for (var i = ind; i < this.rowsCol.length; i++) {
        if (!this.rowsCol[i]) {
            continue;
        }
        if (this.rowsCol[i].style.display != "none") {
            if (this.rowsCol[i]._cntr) {
                j = 1;
                continue;
            }
            if (this.rowsCol[i].className.indexOf("rowselected") != -1) {
                if (j % 2 == 1) {
                    this.rowsCol[i].className =
                        this._cssUnEven + " rowselected " + (this.rowsCol[i]._css || "");
                }
                else {
                    this.rowsCol[i].className =
                        this._cssEven + " rowselected " + (this.rowsCol[i]._css || "");
                }
            }
            else {
                if (j % 2 == 1) {
                    this.rowsCol[i].className =
                        this._cssUnEven + " " + (this.rowsCol[i]._css || "");
                }
                else {
                    this.rowsCol[i].className =
                        this._cssEven + " " + (this.rowsCol[i]._css || "");
                }
            }
            j++;
        }
    }
};
dhtmlXGridObject.prototype.clearChangedState = function () {
    for (var i = 0; i < this.rowsCol.length; i++) {
        var row = this.rowsCol[i];
        if (row && row.childNodes) {
            var cols = row.childNodes.length;
            for (var j = 0; j < cols; j++) {
                row.childNodes[j].wasChanged = false;
            }
        }
    }
};
dhtmlXGridObject.prototype.getChangedRows = function (and_added) {
    var res = new Array();
    this.forEachRow(function (id) {

        var row = this.rowsAr[id];
        if (row.tagName != "TR") {
            return;
        }
        var cols = row.childNodes.length;
        if (and_added && row._added) {
            res[res.length] = row.idd;
        }
        else {
            for (var j = 0; j < cols; j++) {
                if (row.childNodes[j].wasChanged) {
                    res[res.length] = row.idd;
                    break;
                }
            }
        }
    });
    return res.join(this.delim);
};
dhtmlXGridObject.prototype.setSerializationLevel = function (userData, fullXML, config, changedAttr, onlyChanged, asCDATA) {
    this._sUDa = userData;
    this._sAll = fullXML;
    this._sConfig = config;
    this._chAttr = changedAttr;
    this._onlChAttr = onlyChanged;
    this._asCDATA = asCDATA;
};
dhtmlXGridObject.prototype.setSerializableColumns = function (list) {
    if (!list) {
        this._srClmn = null;
        return;
    }
    this._srClmn = (list || "").split(",");
    for (var i = 0; i < this._srClmn.length; i++) {
        this._srClmn[i] = dhx4.s2b(this._srClmn[i]);
    }
};
dhtmlXGridObject.prototype._serialise = function () {
    this.editStop();
    var out = [];
    var close = "</" + this.xml.s_row + ">";
    if (this.isTreeGrid()) {
        this._h2.forEachChildF(0, function (el) {

            var temp = this._serializeRow(this.render_row_tree(-1, el.id));
            out.push(temp);
            if (temp) {
                return true;
            }
            else {
                return false;
            }
        }, this, function () {
            out.push(close);
        });
    }
    else {
        for (var i = 0; i < this.rowsBuffer.length; i++) {
            if (this.rowsBuffer[i]) {
                if (this._chAttr && this.rowsBuffer[i]._locator) {
                    continue;
                }
                var temp = this._serializeRow(this.render_row(i));
                out.push(temp);
                if (temp) {
                    out.push(close);
                }
            }
        }
    }
    return [out.join("")];
};
dhtmlXGridObject.prototype._serializeRow = function (r) {
    var out = [];
    var ra = this.xml.row_attrs;
    var ca = this.xml.cell_attrs;
    out.push("<" + this.xml.s_row);
    out.push(" id='" + r.idd + "'");
    if (this._sAll && this.selectedRows._dhx_find(r) != -1) {
        out.push(" selected='1'");
    }
    if (this._h2 && this._h2.get[r.idd].state == "minus") {
        out.push(" open='1'");
    }
    if (ra.length) {
        for (var i_7 = 0; i_7 < ra.length; i_7++) {
            out.push(" " + ra[i_7] + "='" + r._attrs[ra[i_7]] + "'");
        }
    }
    out.push(">");
    if (this._sUDa && this.UserData[r.idd]) {
        var keysAr = this.UserData[r.idd].getKeys();
        for (var ii = 0; ii < keysAr.length; ii++) {
            var subkey = keysAr[ii];
            if (subkey.indexOf("__") !== 0) {
                out.push("<userdata name='" +
                    subkey +
                    "'>" +
                    (this._asCDATA ? "<![CDATA[" : "") +
                    this.UserData[r.idd].get(subkey) +
                    (this._asCDATA ? "]]>" : "") +
                    "</userdata>");
            }
        }
    }
    var changeFl = false;
    for (var jj = 0; jj < this._cCount; jj++) {
        if (!this._srClmn || this._srClmn[jj]) {
            var zx = this.cells3(r, jj);
            out.push("<cell");
            if (ca.length) {
                for (var i_8 = 0; i_8 < ca.length; i_8++) {
                    out.push(" " + ca[i_8] + "='" + zx.cell._attrs[ca[i_8]] + "'");
                }
            }
            var zxVal = zx[this._agetm]();
            if (this._asCDATA) {
                zxVal = "<![CDATA[" + zxVal + "]]>";
            }
            if (this._ecspn && zx.cell.colSpan && zx.cell.colSpan > 1) {
                out.push(' colspan="' + zx.cell.colSpan + '" ');
            }
            if (this._chAttr) {
                if (zx.wasChanged()) {
                    out.push(' changed="1"');
                    changeFl = true;
                }
            }
            else {
                if (this._onlChAttr && zx.wasChanged()) {
                    changeFl = true;
                }
            }
            if (this._sAll && this.cellType[jj] == "tree") {
                out.push((this._h2 ? " image='" + this._h2.get[r.idd].image + "'" : "") +
                    ">" +
                    zxVal +
                    "</cell>");
            }
            else {
                out.push(">" + zxVal + "</cell>");
            }
            if (this._ecspn && zx.cell.colSpan) {
                for (var u = 0; u < zx.cell.colSpan - 1; u++) {
                    out.push("<cell/>");
                    jj++;
                }
            }
        }
    }
    if (this._onlChAttr && !changeFl && !r._added) {
        return "";
    }
    return out.join("");
};
dhtmlXGridObject.prototype._serialiseConfig = function () {
    var out = "<head>";
    for (var i = 0; i < this.hdr.rows[0].cells.length; i++) {
        if (this._srClmn && !this._srClmn[i]) {
            continue;
        }
        var sort = this.fldSort[i];
        if (sort == "cus") {
            sort = this._customSorts[i].toString();
            sort = sort.replace(/function[\ ]*/, "").replace(/\([^\f]*/, "");
        }
        out +=
            "<column width='" +
                this.getColWidth(i) +
                "' align='" +
                this.cellAlign[i] +
                "' type='" +
                this.cellType[i] +
                "' sort='" +
                (sort || "na") +
                "' color='" +
                (this.columnColor[i] || "") +
                "'" +
                (this.columnIds[i] ? " id='" + this.columnIds[i] + "'" : "") +
                ">";
        if (this._asCDATA) {
            out += "<![CDATA[" + this.getColumnLabel(i) + "]]>";
        }
        else {
            out += this.getColumnLabel(i);
        }
        var z = this.getCombo(i);
        if (z) {
            for (var j = 0; j < z.keys.length; j++) {
                out += "<option value='" + z.keys[j] + "'>" + z.values[j] + "</option>";
            }
        }
        out += "</column>";
    }
    return (out += "</head>");
};
dhtmlXGridObject.prototype.serialize = function () {
    var out = '<?xml version="1.0"?><rows>';
    if (this._mathSerialization) {
        this._agetm = "getMathValue";
    }
    else {
        this._agetm = "getValue";
    }
    if (this._sUDa && this.UserData.gridglobaluserdata) {
        var keysAr = this.UserData.gridglobaluserdata.getKeys();
        for (var i = 0; i < keysAr.length; i++) {
            out +=
                "<userdata name='" +
                    keysAr[i] +
                    "'>" +
                    this.UserData.gridglobaluserdata.get(keysAr[i]) +
                    "</userdata>";
        }
    }
    if (this._sConfig) {
        out += this._serialiseConfig();
    }
    out += this._serialise();
    out += "</rows>";
    return out;
};
dhtmlXGridObject.prototype.getPosition = function (oNode, pNode) {
    if (!pNode) {
        var pos = dhx4.getOffset(oNode);
        return [pos.left, pos.top];
    }
    pNode = pNode || document.body;
    var oCurrentNode = oNode;
    var iLeft = 0;
    var iTop = 0;
    while (oCurrentNode && oCurrentNode != pNode) {
        iLeft += oCurrentNode.offsetLeft - oCurrentNode.scrollLeft;
        iTop += oCurrentNode.offsetTop - oCurrentNode.scrollTop;
        oCurrentNode = oCurrentNode.offsetParent;
    }
    if (pNode == document.body) {
        if (dhx4.isIE) {
            iTop += document.body.offsetTop || document.documentElement.offsetTop;
            iLeft += document.body.offsetLeft || document.documentElement.offsetLeft;
        }
        else {
            if (!_isFF) {
                iLeft += document.body.offsetLeft;
                iTop += document.body.offsetTop;
            }
        }
    }
    return [iLeft, iTop];
};
dhtmlXGridObject.prototype.getFirstParentOfType = function (obj, tag) {
    while (obj && obj.tagName != tag && obj.tagName != "BODY") {
        obj = obj.parentNode;
    }
    return obj;
};
dhtmlXGridObject.prototype.enableCollSpan = dhtmlXGridObject.prototype.enableColSpan;
dhtmlXGridObject.prototype.setMultiselect = dhtmlXGridObject.prototype.enableMultiselect;
dhtmlXGridObject.prototype.setMultiLine = dhtmlXGridObject.prototype.enableMultiline;
dhtmlXGridObject.prototype.deleteSelectedItem = dhtmlXGridObject.prototype.deleteSelectedRows;
dhtmlXGridObject.prototype.getSelectedId = dhtmlXGridObject.prototype.getSelectedRowId;
dhtmlXGridObject.prototype.getHeaderCol = dhtmlXGridObject.prototype.getColumnLabel;
dhtmlXGridObject.prototype.isItemExists = dhtmlXGridObject.prototype.doesRowExist;
dhtmlXGridObject.prototype.getColumnCount = dhtmlXGridObject.prototype.getColumnsNum;
dhtmlXGridObject.prototype.setSelectedRow = dhtmlXGridObject.prototype.selectRowById;
dhtmlXGridObject.prototype.setHeaderCol = dhtmlXGridObject.prototype.setColumnLabel;
dhtmlXGridObject.prototype.preventIECashing = dhtmlXGridObject.prototype.preventIECaching;
dhtmlXGridObject.prototype.enableAutoHeigth = dhtmlXGridObject.prototype.enableAutoHeight;
dhtmlXGridObject.prototype.getUID = dhtmlXGridObject.prototype.uid;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods00000.js